
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M6.57 8v8","fill":"none","stroke":"#21245c","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":"1.2"}}),_c('path',{attrs:{"d":"M6.57 16L5 14.43M8.137 14.433L6.57 16","fill":"none","stroke":"#21245c","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":"1.2"}}),_c('g',{attrs:{"fill":"none","stroke":"#21245c","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":"1.2"}},[_c('path',{attrs:{"d":"M15.888 9h-3.723M17.888 12h-5.723M19.888 15h-7.723"}})])])
          )
        }
      }
    